function StarterPage() {
    return (
        <div className="flex flex-col items-center justify-center w-full gap-4 py-20 bg-white rounded-xl ">
            <img
                src="/images/courses/noVideoOpening.webp"
                alt="Lecture content page start page image"
                decoding="async"
                loading="lazy"
            />
            <h2 className="text-xl text-blue-color-primary">
                يمكنك مشاهدة الفيديوهات
            </h2>
            <p className="text-lg leading-8 tracking-wide text-center text-gray-color-primary">
                أنتبه يمكنك فتح الفيديوهات ومشاهدتها عدد مرات محدود
                <br />
                ويمكنك أيضاً تحميل الملفات المرفقة للمحاضره
            </p>
        </div>
    );
}

export default StarterPage;
